import { render, staticRenderFns } from "./OrgUploadedDocs.vue?vue&type=template&id=6a0c6912&scoped=true"
import script from "./OrgUploadedDocs.vue?vue&type=script&lang=js"
export * from "./OrgUploadedDocs.vue?vue&type=script&lang=js"
import style0 from "./OrgUploadedDocs.vue?vue&type=style&index=0&id=6a0c6912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c6912",
  null
  
)

export default component.exports